function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/TOOLS/ico-30-trash");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/TOOLS/ico-30-trash",
  stroke: "#000000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(6.500000, 4.500000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,4 L15.0830539,18.588083 C15.0364161,19.380927 14.3798568,20 13.5856424,20 L4.41435762,20 C3.62014316,20 2.96358394,19.380927 2.91694606,18.588083 L2,4 M9,5.5 L9,17.5 M5.3,5.5 L6,17.5 M12.7,5.5 L12,17.5",
  id: "Combined-Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5,1 C6.5,0.44771525 6.94771525,0 7.5,0 L10.5,0 C11.0522847,0 11.5,0.44771525 11.5,1 L11.5,2 L6.5,2 L6.5,1 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,3 C-6.76353751e-17,2.44771525 0.44771525,2 1,2 L17,2 C17.5522847,2 18,2.44771525 18,3 L18,3 L18,3",
  id: "Path"
}))));

const SvgIco30Trash = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Trash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-trash.95fe6a1e.svg";
export { ForwardRef as ReactComponent };